import React, { useEffect, useRef, useState } from 'react';
import { GridColDef, GridRowId } from '@mui/x-data-grid';
import { Alert, AlertColor, AppBar, Box, Button, CircularProgress, createTheme, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useApi } from './../../services/HttpService';
import ScrollableDataGrid from './../../components/tables/ScrollableDataGrid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import BaseModal from './../../components/modals/BaseModal';
import { StickyAlert } from './../../components/ui/StickyAlert';
import { highlightedGridColumns } from './../../components/tables/BaseTable';
import { User, newUser } from './../../model';
import { EmailSetting, newEmailSetting, EmailProvider, newEmailProvider, SendEmailInfo, newSendEmailInfo } from './../../model/Email';
import { EnhancedTableToolbar } from './../../components/tables/AdminTable';
import HardDeleteDialog from './../../components/modals/dialog/HardDeleteDialog';
import { EmailSettingOverview } from './manage/email/EmailSettingOverview';
import { EmailProviderForm, EmailProviderFormRef } from './../../model/forms/EmailProviderForm';
import { SendEmailForm, SendEmailInfoFormRef } from '../../model/forms/SendEmailForm';

const mainColumns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'name', headerName: 'Navn', width: 250 },
  { field: 'username', headerName: 'Brukernavn', width: 200 },
  { field: 'password', headerName: 'Passord', width: 150 },
  { field: 'sys_email_provider', headerName: 'E-post leverandør', width: 150 },
  { field: 'auth_by_user', headerName: 'Brukerautorisering', width: 200 , type: 'boolean'},
];

export const SendMailDefault = () => {
  const theme = useTheme();
  const { api, isLoading, error } = useApi();
  const { api: deleteApi, isLoading: deleteIsLoading, error: deleteError } = useApi();
  const { api: dataApi, error: dataError } = useApi();
  const [item, setItem] = useState<SendEmailInfo>(newSendEmailInfo());
  const [user, setUser] = useState<User>(newUser());
  const [selectedSendEmailInfo, setSelectedSendEmailInfo] = useState<SendEmailInfo>();
  const [EmailSettings, setEmailSettings] = useState<EmailProvider[]>([]);
  const addSendEmailInfoFormRef = useRef<SendEmailInfoFormRef>(null);
  const [displayData, setDisplayData] = useState<Record<string, string>>(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<AlertColor | undefined>('error');
  
  const apiRef = useRef<GridApiCommunity>(null);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));


  React.useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    api("/manage/email/getEmailSettings", "POST", { search: "", limit: 0 }).then((res) => {
      if (res?.statusCode === 200) {
        setEmailSettings(res.data);
      }
    });

    api("/api/me", "GET").then((res) => {
      if (res?.statusCode === 200) {
        setUser(res.user);
        
        if (user.emailaddress != null){
          setItem((prev) => ({ ...prev, ["recipient_email"]: user.emailaddress }));
        }
      }
    });
  }

  const reset = () => {
    setItem(() => ({ ...item, password: "" })); // triggers props.paymentprofile change in PaymentprofileForm
  }

  const setDisplayMessage = (message: string, type: AlertColor = 'error') => {
    setMessage(message);
    setMessageType(type);
  }

  const saveItem = () => {

    // Validate the form
    if (!addSendEmailInfoFormRef.current.valid()) {
      console.log("Validation failed");
      return;
    }
  
    // Get form data
    const EmailRef = addSendEmailInfoFormRef.current.getItem();
    console.log("Saving data:", EmailRef);

    if (addSendEmailInfoFormRef.current.valid()) {
      api("/email/SendSingleEmail", "POST", { ...EmailRef }).then(res => {
        console.log("res:", res)
        if (res?.statusCode === 200) {
          setDisplayMessage("Email er sendt", "success")
          setSelectedSendEmailInfo(newSendEmailInfo())
        } else {
          if (res.error) {
            if (res.error.code === "1") {
              setDisplayMessage("Det er skjedd en feil under sending av epost");
            } else if (res.error.code === "2") {
              setDisplayMessage("Test");
            } else {
              setDisplayMessage("Det er skjedd en feil under sending av epost");
            }
          }
        }
      });
    }
  };

  return (
    <>
      <Box sx={{ m: 1, mt: 3, p: { xs: 1, md: 3 }, pt: 0, width: "100%" }}>
        <Box sx={{ maxWidth: 1000 , alignItems: 'center', alignSelf: 'center' }}>
          <SendEmailForm item={item} error={""} user={user} ref={addSendEmailInfoFormRef} EmailSettingList={EmailSettings} />
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'right', flexWrap: 'wrap', gap: 2, maxWidth: 1000, width: "100%" }}>
              <Button 
                variant='contained' 
                color='darkgrey' 
                onClick={reset}
              >
                Tilbakestill
              </Button>
              <Button
                variant='contained'
                color='info'
                onClick={saveItem}
                disabled={isLoading}
                endIcon={isLoading && <CircularProgress size={22} />}
              >
                {"Send e-post"}
              </Button>
            </Box>
          </Box>
          <Box sx={{ mt: '15px', width: '50ch' }}>
            {message && <Alert severity={messageType}>{message}</Alert>}
          </Box>
        </Box>
      </Box>
    </>
  )
}